import { render, staticRenderFns } from "./PackageToStock.vue?vue&type=template&id=1db7f084&scoped=true"
import script from "./PackageToStock.vue?vue&type=script&lang=js"
export * from "./PackageToStock.vue?vue&type=script&lang=js"
import style0 from "./PackageToStock.vue?vue&type=style&index=0&id=1db7f084&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db7f084",
  null
  
)

export default component.exports